/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    if (this.cartEventController) return;
    this.cartEventController = new AbortController();
    const options = { signal: this.cartEventController.signal };
    document.addEventListener('dispatch:cart-drawer:open', this.handleDrawerOpenViaEvent.bind(this), options);
    document.addEventListener('dispatch:cart-drawer:close', this.close.bind(this, null), options);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler.bind(this), options);
    const prepareContent = () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    };
    this.addEventListener('on:cart-drawer:before-open', prepareContent, options);
    this.addEventListener('on:cart:after-merge', prepareContent, options);
  }

  disconnectedCallback() {
    this.cartEventController?.abort();
    this.cartEventController = null;
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

(() => {
  const openDrawer = (opener) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return false;
    drawer.open(opener || null);
    return true;
  };

  window.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    const cartUrl = new URL(theme.routes.cart, location.origin);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== cartUrl.pathname.replace(/\/$/, '') || url.search) return;
    if (openDrawer(link)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const openRequestedDrawer = () => {
    const url = new URL(location.href);
    if (url.searchParams.get('sc_cart') !== '1' || !openDrawer()) return;
    url.searchParams.delete('sc_cart');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openRequestedDrawer, { once: true });
  } else {
    openRequestedDrawer();
  }
})();
